import usePreference from './usePreference';
import { densityPref } from '@/lib/density';

// Reactive accessor for the table-density preference.
// Returns [density, setDensity]; re-renders all subscribers when density changes.
export default function useDensity() {
  return usePreference(densityPref);
}
